export default "__VITE_ASSET__CCVST$E6__"